/**
 * Matches 1:1 with "credit_card" repo under:
 * product/dashboard/src/helpers/password.ts
 *
 * Please make sure all changes match up
 */

import memoize from "memoize-one";
import zxcvbn from "zxcvbn";

export const minimumScore = 2;
export const minimumLength = 8;

export const validate = memoize((password: string) => zxcvbn(password));

export const hasLowercaseRegex = /.*[a-z].*/;
export const hasLowercaseLetter = (str: string) => hasLowercaseRegex.test(str);
export const hasUppercaseRegex = /.*[A-Z].*/;
export const hasUppercaseLetter = (str: string) => hasUppercaseRegex.test(str);

export const isValid = (password: string): boolean =>
  hasLowercaseLetter(password) &&
  hasUppercaseLetter(password) &&
  password?.length >= minimumLength &&
  validate(password).score >= minimumScore;
